const { BorderedCircleSkeleton } = require('components/base/Skeletons');

const Loader = () => {
  return (
    <div data-cy='allocation-over-time-loader'>
      <BorderedCircleSkeleton borderSize={45} size={13} />
    </div>
  );
};

export default Loader;
